import Vue from 'vue'
import mascaras from '@/util/mascaras'

export default {
  name: 'TelefoneInput',
  directives: {
    mask: Vue.directive('mask')
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    mask: {
      type: String,
      default: mascaras.mascarasParaCampos.celular
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedPhone: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    handleInput (event) {
      this.formattedPhone = event.target.value
    }
  },
  render (h) {
    return h('input', {
      directives: [
        {
          name: 'mask',
          value: this.mask
        }
      ],
      attrs: {
        type: 'tel',
        placeholder: this.placeholder,
        ...(this.$attrs || {})
      },
      domProps: {
        value: this.formattedPhone
      },
      on: {
        input: this.handleInput
      }
    })
  }
}
